@if(corpType){
<div class="relative" #pickerContainer>
    <corp-control-title class="absolute block" [corp-title]="corpLabel" [corp-size]="corpSize" [corp-disabled]="disabled"></corp-control-title>

    @if(isForm) {
    <!-- Input personnalisé pour TOUS les types -->
    <div class="relative">
        <input type="text"
               readonly
               class="corp-control cursor-pointer"
               [ngClass]="[
                        'corp-control-' + corpSize,
                        (ngControl?.invalid && (ngControl?.touched || ngControl?.dirty)) ? 'border-red-500' : ''
                    ]"
               [value]="getDisplayDate()"
               (click)="togglePicker()"
               [disabled]="disabled"
               [placeholder]="getPlaceholder() | translate" />
        <button type="button"
                class="absolute top-1/2 right-2 -translate-y-1/2 text-gray-500 transition-colors hover:text-primary-500"
                (click)="togglePicker()"
                [disabled]="disabled">
            @if(corpType === 'time') {
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            } @else {
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            }
        </button>
    </div>

    <!-- Panneau personnalisé COMPACT -->
    @if(showCustomPicker()) {
    <div class="animate-fade-in absolute z-50 mt-1 w-64 rounded-lg border border-gray-200 bg-white p-3 shadow-xl dark:border-gray-700 dark:bg-gray-800">

        <!-- Vue pour DATE -->
        @if(corpType === 'date') {
        <div class="mb-2 flex items-center justify-between">
            <button type="button" (click)="previousMonth()" class="rounded p-1 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                <svg class="h-4 w-4 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <h5 class="text-sm font-semibold text-gray-900 capitalize dark:text-white">{{ lang(getMonthName()) | translate }}</h5>
            <button type="button" (click)="nextMonth()" class="rounded p-1 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                <svg class="h-4 w-4 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>

        <div class="mb-1 grid grid-cols-7 gap-0.5">
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">L</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">M</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">M</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">J</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">V</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">S</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">D</div>
        </div>

        <div class="grid grid-cols-7 gap-0.5">
            @for(day of calendarDays(); track day.date.getTime()) {
            <button type="button" (click)="selectDate(day)"
                    [ngClass]="{
                                        'text-gray-400 dark:text-gray-600': !day.isCurrentMonth,
                                        'text-gray-900 dark:text-white': day.isCurrentMonth,
                                        'bg-primary-500 text-white hover:bg-primary-600': day.isSelected,
                                        'ring-1 ring-primary-500': day.isToday && !day.isSelected,
                                        'hover:bg-gray-100 dark:hover:bg-gray-700': !day.isSelected
                                    }"
                    class="flex h-7 w-7 items-center justify-center rounded text-xs font-medium transition-all duration-150">
                {{ day.date.getDate() }}
            </button>
            }
        </div>

        <div class="mt-2 border-t border-gray-200 pt-2 dark:border-gray-700">
            <button type="button" (click)="selectToday()" class="text-primary-600 w-full rounded px-3 py-1 text-xs font-medium transition-colors hover:bg-primary-50 dark:text-primary-400 dark:hover:bg-primary-900/20">
                Aujourd'hui
            </button>
        </div>
        }

        <!-- Vue pour WEEK (Liste des semaines) -->
        @if(corpType === 'week') {
        <div class="mb-2 flex items-center justify-between">
            <button type="button" (click)="previousYear()" class="rounded p-1 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                <svg class="h-4 w-4 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <h5 class="text-sm font-semibold text-gray-900 dark:text-white">{{ currentYear() }}</h5>
            <button type="button" (click)="nextYear()" class="rounded p-1 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                <svg class="h-4 w-4 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>

        <div class="max-h-60 overflow-y-auto rounded border border-gray-200 dark:border-gray-700">
            @for(week of weekList(); track week.weekNumber) {
            <button type="button" (click)="selectWeek(week)"
                    [ngClass]="{
                                        'bg-primary-500 text-white hover:bg-primary-600': week.isSelected,
                                        'ring-1 ring-inset ring-primary-500': week.isCurrentWeek && !week.isSelected,
                                        'hover:bg-gray-100 dark:hover:bg-gray-700': !week.isSelected
                                    }"
                    class="w-full border-b border-gray-100 px-3 py-2 text-left text-sm transition-colors last:border-b-0 dark:border-gray-700">
                <div class="flex items-center justify-between">
                    <span class="font-semibold">S{{ week.weekNumber }}</span>
                    <span class="text-xs opacity-75">
                        {{ week.startDate.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }) }} -
                        {{ week.endDate.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }) }}
                    </span>
                </div>
            </button>
            }
        </div>

        <div class="mt-2 border-t border-gray-200 pt-2 dark:border-gray-700">
            <button type="button" (click)="selectThisWeek()" class="text-primary-600 w-full rounded px-3 py-1 text-xs font-medium transition-colors hover:bg-primary-50 dark:text-primary-400 dark:hover:bg-primary-900/20">
                Cette semaine
            </button>
        </div>
        }

        <!-- Vue pour MONTH -->
        @if(corpType === 'month') {
        <div class="mb-2 flex items-center justify-between">
            <button type="button" (click)="previousYear()" class="rounded p-1 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                <svg class="h-4 w-4 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <h5 class="text-sm font-semibold text-gray-900 dark:text-white">{{ currentMonth().getFullYear() }}</h5>
            <button type="button" (click)="nextYear()" class="rounded p-1 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                <svg class="h-4 w-4 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>

        <div class="grid grid-cols-3 gap-2">
            @for(month of monthNames; track month; let i = $index) {
            <button type="button" (click)="selectMonth(i)"
                    [ngClass]="{'bg-primary-500 text-white': isSelectedMonth(i), 'ring-1 ring-primary-500': isCurrentMonth(i) && !isSelectedMonth(i)}"
                    class="rounded p-2 text-center text-sm font-medium text-gray-900 transition-colors hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700">
                {{ month }}
            </button>
            }
        </div>

        <div class="mt-2 border-t border-gray-200 pt-2 dark:border-gray-700">
            <button type="button" (click)="selectThisMonth()" class="text-primary-600 w-full rounded px-3 py-1 text-xs font-medium transition-colors hover:bg-primary-50 dark:text-primary-400 dark:hover:bg-primary-900/20">
                Ce mois
            </button>
        </div>
        }

        <!-- Vue pour TIME -->
        @if(corpType === 'time') {
        <div class="mb-2 text-center text-sm font-semibold text-gray-900 dark:text-white">Sélectionner l'heure</div>

        <div class="grid grid-cols-2 gap-2">
            <div>
                <div class="mb-1 text-center text-xs font-semibold text-gray-600 dark:text-gray-400">Heures</div>
                <div class="max-h-40 overflow-y-auto rounded border border-gray-200 dark:border-gray-700">
                    @for(h of hours; track h) {
                    <button type="button" (click)="selectHour(h)"
                            [ngClass]="{'bg-primary-500 text-white': h === selectedHour()}"
                            class="w-full px-2 py-1 text-center text-sm transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                        {{ h.toString().padStart(2, '0') }}
                    </button>
                    }
                </div>
            </div>
            <div>
                <div class="mb-1 text-center text-xs font-semibold text-gray-600 dark:text-gray-400">Minutes</div>
                <div class="max-h-40 overflow-y-auto rounded border border-gray-200 dark:border-gray-700">
                    @for(m of minutes; track m) {
                    <button type="button" (click)="selectMinute(m)"
                            [ngClass]="{'bg-primary-500 text-white': m === selectedMinute()}"
                            class="w-full px-2 py-1 text-center text-sm transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                        {{ m.toString().padStart(2, '0') }}
                    </button>
                    }
                </div>
            </div>
        </div>

        <div class="mt-2 border-t border-gray-200 pt-2 dark:border-gray-700">
            <button type="button" (click)="applyTime()" class="text-primary-600 w-full rounded px-3 py-1 text-xs font-medium transition-colors hover:bg-primary-50 dark:text-primary-400 dark:hover:bg-primary-900/20">
                Valider
            </button>
        </div>
        }

        <!-- Vue pour DATETIME-LOCAL -->
        @if(corpType === 'datetime-local') {
        <div class="mb-2 flex items-center justify-between">
            <button type="button" (click)="previousMonth()" class="rounded p-1 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                <svg class="h-4 w-4 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <h5 class="text-sm font-semibold text-gray-900 capitalize dark:text-white">{{ lang(getMonthName()) | translate }}</h5>
            <button type="button" (click)="nextMonth()" class="rounded p-1 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                <svg class="h-4 w-4 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>

        <div class="mb-1 grid grid-cols-7 gap-0.5">
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">L</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">M</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">M</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">J</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">V</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">S</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">D</div>
        </div>

        <div class="mb-2 grid grid-cols-7 gap-0.5">
            @for(day of calendarDays(); track day.date.getTime()) {
            <button type="button" (click)="selectDateTimeDate(day)"
                    [ngClass]="{
                                        'text-gray-400 dark:text-gray-600': !day.isCurrentMonth,
                                        'text-gray-900 dark:text-white': day.isCurrentMonth,
                                        'bg-primary-500 text-white hover:bg-primary-600': day.isSelected,
                                        'ring-1 ring-primary-500': day.isToday && !day.isSelected,
                                        'hover:bg-gray-100 dark:hover:bg-gray-700': !day.isSelected
                                    }"
                    class="flex h-7 w-7 items-center justify-center rounded text-xs font-medium transition-all duration-150">
                {{ day.date.getDate() }}
            </button>
            }
        </div>

        <div class="border-t border-gray-200 pt-2 dark:border-gray-700">
            <div class="mb-1 text-center text-xs font-semibold text-gray-600 dark:text-gray-400">Heure</div>
            <div class="grid grid-cols-2 gap-2">
                <div>
                    <div class="max-h-32 overflow-y-auto rounded border border-gray-200 dark:border-gray-700">
                        @for(h of hours; track h) {
                        <button type="button" (click)="selectHour(h)"
                                [ngClass]="{'bg-primary-500 text-white': h === selectedHour()}"
                                class="w-full px-2 py-1 text-center text-xs transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                            {{ h.toString().padStart(2, '0') }}h
                        </button>
                        }
                    </div>
                </div>
                <div>
                    <div class="max-h-32 overflow-y-auto rounded border border-gray-200 dark:border-gray-700">
                        @for(m of minutes; track m) {
                        <button type="button" (click)="selectMinute(m)"
                                [ngClass]="{'bg-primary-500 text-white': m === selectedMinute()}"
                                class="w-full px-2 py-1 text-center text-xs transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                            {{ m.toString().padStart(2, '0') }}m
                        </button>
                        }
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-2 border-t border-gray-200 pt-2 dark:border-gray-700">
            <button type="button" (click)="applyDateTime()" class="text-primary-600 w-full rounded px-3 py-1 text-xs font-medium transition-colors hover:bg-primary-50 dark:text-primary-400 dark:hover:bg-primary-900/20">
                Valider
            </button>
        </div>
        }

        <!-- Vue pour DATE_RANGE (Plage de dates) -->
        @if(corpType === 'date_range') {
        <div class="mb-2 flex items-center justify-between">
            <button type="button" (click)="previousMonth()" class="rounded p-1 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                <svg class="h-4 w-4 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <h5 class="text-sm font-semibold text-gray-900 capitalize dark:text-white">{{ lang(getMonthName()) | translate }} {{ getYear() }}</h5>
            <button type="button" (click)="nextMonth()" class="rounded p-1 transition-colors hover:bg-gray-100 dark:hover:bg-gray-700">
                <svg class="h-4 w-4 text-gray-600 dark:text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>

        <div class="mb-1 grid grid-cols-7 gap-0.5">
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">L</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">M</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">M</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">J</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">V</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">S</div>
            <div class="py-1 text-center font-semibold text-[10px] text-gray-600 dark:text-gray-400">D</div>
        </div>

        <div class="grid grid-cols-7 gap-0.5">
            @for(day of calendarDays(); track day.date.getTime()) {
            <button type="button"
                    (mousedown)="onDateRangeMouseDown(day)"
                    (mouseenter)="onDateRangeMouseEnter(day)"
                    [ngClass]="{
                    'text-gray-400 dark:text-gray-600': !day.isCurrentMonth,
                    'text-gray-900 dark:text-white': day.isCurrentMonth && !day.isInRange,
                    'bg-primary-500 text-white hover:bg-primary-600': day.isRangeStart || day.isRangeEnd,
                    'bg-primary-100 dark:bg-primary-900/30 text-primary-900 dark:text-primary-100': day.isInRange && !day.isRangeStart && !day.isRangeEnd,
                    'ring-1 ring-primary-500': day.isToday && !day.isInRange,
                    'hover:bg-gray-100 dark:hover:bg-gray-700': !day.isInRange && day.isCurrentMonth,
                    'rounded-l-lg': day.isRangeStart && !day.isRangeEnd,
                    'rounded-r-lg': day.isRangeEnd && !day.isRangeStart,
                    'rounded-lg': (day.isRangeStart && day.isRangeEnd) || (!day.isInRange && !day.isRangeStart && !day.isRangeEnd)
                }"
                    class="flex h-7 w-7 items-center justify-center text-xs font-medium transition-all duration-150 select-none">
                {{ day.date.getDate() }}
            </button>
            }
        </div>

        <div class="mt-2 flex gap-2 border-t border-gray-200 pt-2 dark:border-gray-700">
            <button type="button" (click)="applyDateRange()"
                    [disabled]="!dateRange().start || !dateRange().end"
                    class="text-primary-600 flex-1 rounded px-3 py-1 text-xs font-medium transition-colors hover:bg-primary-50 disabled:cursor-not-allowed disabled:opacity-50 dark:text-primary-400 dark:hover:bg-primary-900/20">
                {{lang('Valider') | translate}}
            </button>
            <button type="button" (click)="clearDateRange()"
                    class="flex-1 rounded px-3 py-1 text-xs font-medium text-gray-600 transition-colors hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-700">
                {{lang('Effacer') | translate}}
            </button>
        </div>
        }

    </div>
    }
    }
    @else {
    <input type="text" readonly [value]="corpValue" [ngClass]="['corp-control corp-control-' + corpSize]" />
    }
</div>
}












